import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-loading-icon',
  templateUrl: './code-loading.component.html'
})
export class CodeLoadingComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
